<script setup lang="ts">
defineProps<{ podcasts: PodcastCard[] }>();
</script>

<template>
  <UContainer>
    <ul v-if="podcasts?.length" class="flex flex-wrap justify-center gap-4">
      <li v-for="(podcast, index) in podcasts" :key="podcast.id">
        <NuxtLink
          :to="podcast.slug.full"
          :aria-label="`podkast ${index + 1} av ${podcasts.length}: ${podcast.title}`"
        >
          <CrystallizeImage
            :image="podcast.cover"
            img-class="max-h-full w-[370px] rounded-xl object-contain"
          />
        </NuxtLink>
      </li>
    </ul>
  </UContainer>
</template>
